/**
 * Created by Ivan on 09.12.2025
 */

// eslint-disable-next-line
let LightningRushWindow = cc.Node.extend({
    ctor: function (...args) {
        this._super();

        this._windowArgs = args;
        const bundles = cleverapps.config.type === "merge2" ? ["lightning_rush_window"] : ["mission_window"];
        ComponentMap.attach(this, new WindowComponent(bundles));
    },

    onWindowLoaded: function (mission) {
        this.withShadow = true;

        this.mission = mission;
        this.name = `${mission.getName()}_missionwindow`;

        const closeWindowCallback = () => {
            ComponentMap.get(this, WindowComponent).closeWindow();
        };

        const controller = this.controller = new LightningRushWindowController({ mission, closeWindowCallback });
        ComponentMap.attach(this, controller);

        this.resizable = new Resizable({
            createHorizontalView: function () {
                const contentType = controller.getContentType();
                if (contentType === "garden") {
                    return new LightningRushGardenContent(controller, { closeWindowCallback });
                }
                return new LightningRushHorizontalContent(controller, { closeWindowCallback });
            },
            createVerticalView: function () {
                const contentType = controller.getContentType();
                if (contentType === "garden") {
                    return new LightningRushGardenContent(controller, { closeWindowCallback });
                }
                return new LightningRushVerticalContent(controller, { closeWindowCallback });
            }
        });
        ComponentMap.attach(this, this.resizable);

        this.onResize();

        this.mission.updateCompetitionResults();
    },

    onResize: function () {
        const sceneSize = cleverapps.resolution.getSceneSize();
        this.setContentSize(sceneSize.width, sceneSize.height);
        this.setPosition(sceneSize.width / 2, sceneSize.height / 2);

        if (this.resizable) {
            this.resizable.onResize();

            const layout = this.resizable.content && this.resizable.content.layout;
            if (layout) {
                cleverapps.UI.inflateToBoundaries(layout, [], {
                    padding: cleverapps.styles.LightningRushWindow.padding,
                    maxScale: 1
                });
            }
        }
    },

    onHide: function () {
        this.controller.onHide();
    },

    onClose: function () {
        this.controller.onClose();
    }
});

cleverapps.overrideStyles(cleverapps.styles.DECORATORS, {
    MISSION_STROKE: {
        color: new cc.Color(95, 29, 17, 128),
        size: 1
    },

    MISSION_SHADOW: {
        color: new cc.Color(11, 13, 37, 128),
        direction: cc.size(0, -3),
        blur: 4
    }
});

cleverapps.styles.LightningRushWindow = {
    margin: 30,

    padding: {
        x: 75
    },

    table: {
        margin: -2
    },

    button: {
        x: { align: "center", dx: -25 },
        y: { align: "center" },
        width: 400,
        height: 110,
        red: true
    },

    window: {
        windowShowUpAnimation: undefined
    },

    helpButton: {
        scale: 0.85
    },

    closeButton: {
        scale: [0.7, 1, 1],
        x: { align: "center" },
        y: { align: "center" }
    }
};
